module.exports = {"210402001":"站前街道","210402005":"福民街道","210402007":"新抚街道","210402009":"榆林街道","210402011":"永安台街道","210402019":"刘山街道","210402201":"千金乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210402.json
// module id = 620
// module chunks = 0